// Backend API URL.
// Admin user-і UI-тен «DEV/PROD» режимін ауыстыра алады — таңдау localStorage-та
// `server_mode` кілтінде сақталады, ауысқанда бет қайта жүктеледі (барлық API
// модулі модуль жүктелген кезде осы URL-ды импорттайды).

export const SERVER_MODE_KEY = "server_mode";

// Прод (live юзерлер) — backend сервисі, agroland_dev DB-ға қосылған.
export const PROD_API_URL =
  process.env.REACT_APP_API_URL ||
  "https://backend-237397542353.europe-central2.run.app";

// Test/dev — backend-test сервисі, agroland_test DB-сы.
export const DEV_API_URL =
  process.env.REACT_APP_API_URL_DEV ||
  "https://backend-test-237397542353.europe-central2.run.app";

export const SERVER_MODES = {
  PROD: { value: "prod", label: "PROD", url: PROD_API_URL, color: "#dc2626" },
  DEV: { value: "dev", label: "DEV (test)", url: DEV_API_URL, color: "#16a34a" },
};

/** localhost-та (npm start) жүгіріп тұрмыз ба? */
function isLocalDev() {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "[::1]";
}

/** Returns "prod" | "dev".
 *
 * Әдепкі: жарияланған панельде — "prod", ал ЛОКАЛДЫ жүгіргенде — "dev".
 * Себебі: әзірлеу кезінде байқаусыз прод дерегін өзгертіп алу қаупі бар.
 * Ауыстырғыш бұрынғыша UI-да қалады, таңдау localStorage-та сақталса — ол басым.
 */
export function getServerMode() {
  if (typeof window === "undefined") return "prod";
  const stored = window.localStorage.getItem(SERVER_MODE_KEY);
  if (stored === "dev" || stored === "prod") return stored;
  return isLocalDev() ? "dev" : "prod";
}

export function getCurrentServerConfig() {
  return getServerMode() === "dev" ? SERVER_MODES.DEV : SERVER_MODES.PROD;
}

/** Live API_URL — модуль жүктелгенде бір рет анықталады. */
export const API_URL = getCurrentServerConfig().url;
